import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from "./shared/shared.module";
import { AppRoutingModule } from './app-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';

// // for HttpClient import:
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
// // for Router import:
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
// // for Core import:
import { LoadingBarModule } from '@ngx-loading-bar/core';


import { AdminGuard } from './shared/guard/admin.guard';

import { CookieService } from 'ngx-cookie-service';


import { environment } from '../environments/environment';


import { AppComponent } from './app.component';
 

import { OverlayModule } from '@angular/cdk/overlay';
import { LoginComponent } from './pages/login/login.component';

import { BasicAuthInterceptor } from './shared/_helper/basic-auth.interceptor';
import { ErrorInterceptor } from './shared/_helper/error.interceptor';
import { PdfViewerModule } from 'ng2-pdf-viewer';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    AppComponent, LoginComponent, 
  ],
  imports: [
    BrowserModule,
      FormsModule, PdfViewerModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    OverlayModule,
    SharedModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    ToastrModule.forRoot(),
    //AngularFireModule.initializeApp(environment.firebase),
    //AngularFirestoreModule,
   // AngularFireAuthModule,
      NgSelectModule,
      ToastrModule.forRoot({
          timeOut: 20010000110,
          positionClass: 'toast-bottom-left', 
          progressBar: true



      }

      ),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
    }),
//     // for HttpClient use:
    LoadingBarHttpClientModule,
//     // for Router use:
    LoadingBarRouterModule,
//     // for Core use:
    LoadingBarModule
  ],
  providers: [
    //AuthService,
     AdminGuard, 
   // SecureInnerPagesGuard, 
    CookieService,
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
